import React from 'react'
import { Link } from 'react-router'
const NoAccess = () => {
    return (
        <div style={{ position: 'fixed', top: '72%', left: '58%', transform: 'translate(-50%, -58%)', color: '#000000', textAlign: 'center' }}>
            <br /><br />
            Sorry, You do not have access to the Page.<br />
            Please contact to Acumen for access <Link to="/assets-listing">Go Back</Link>
        </div>)
}

export default NoAccess